// Bar.tsx
import React from 'react';
import './bar.component.scss';

interface BarProps {
    role: string;
    durationPercentage: number;
    startTimePercentage: number;
    customClass: string
}

const Bar: React.FC<BarProps> = ({ role, durationPercentage, startTimePercentage, customClass }) => {

    return (
        <div className='bar-control'>
            <div
                className={`bar-customer bg-${customClass}`}
                style={{
                    width: `${durationPercentage}%`,
                    left: `${startTimePercentage}%`,
                }}
            >
                {/* Add any additional styling or content here */}
            </div>
        </div>
    );
};

export default Bar;